(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8217],{

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1850);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),

/***/ 64625:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referrals",
      function () {
        return __webpack_require__(85308);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FeaturesSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44087);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20978);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shared_LinkWithArrow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35413);








var FeaturesSection = function(param) {
    var title = param.title, sections = param.sections;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-20",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-[1260px] px-4 mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_3__.HorizontalRule, {
                    bottomMargin: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-h2 font-semibold leading-compact text-center mb-16",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col space-y-16 md:space-y-16",
                    children: sections.map(function(section, i) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col md:flex-row items-center gap-6 md:gap-[122px]", {
                                "md:flex-row-reverse": (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .isOdd */ .rA)(i),
                                "mb-[60px]": i < 0
                            }),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full max-w-[600px] md:w-[50%]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                                        priority: true,
                                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, section.image.responsiveImage), {
                                            sizes: "586px"
                                        }),
                                        objectFit: "cover",
                                        layout: "responsive"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full max-w-[600px] md:w-[50%]",
                                    children: [
                                        (section === null || section === void 0 ? void 0 : section.icon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                                            priority: true,
                                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, section.icon.responsiveImage), {
                                                height: 30
                                            }),
                                            objectFit: "cover",
                                            layout: "fixed",
                                            className: "mb-4"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-h3 font-semibold mb-5",
                                            children: section.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-lg",
                                            children: section.description
                                        }),
                                        (section === null || section === void 0 ? void 0 : section.ctaHref) && (section === null || section === void 0 ? void 0 : section.ctaText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mt-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_LinkWithArrow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                shouldChill: true,
                                                href: section.ctaHref,
                                                children: section.ctaText
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, section.id);
                    })
                })
            ]
        })
    });
};



/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ IconFeatures3up; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44087);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43832);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48827);






var IconFeatures3up = function(param) {
    var title = param.title, items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("bg-white"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_2__.HorizontalRule, {
                    bottomMargin: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-h2 font-semibold leading-compact text-center mb-14 lg:mb-16",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 md:gap-6 gap-10",
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-auto md:h-[75px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                                        data: item.icon.responsiveImage,
                                        className: "pointer-events-none mx-auto",
                                        priority: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-h3 font-semibold leading-compact text-center mt-6 md:mt-4 mb-4",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-16",
                                    children: item.description
                                })
                            ]
                        }, item.title);
                    })
                })
            ]
        })
    });
};



/***/ }),

/***/ 85308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ referrals; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/useQuerySubscription/index.js + 2 modules
var useQuerySubscription = __webpack_require__(63430);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var renderMetaTags = __webpack_require__(12569);
// EXTERNAL MODULE: ./src/components/index.ts + 103 modules
var components = __webpack_require__(80338);
// EXTERNAL MODULE: ./node_modules/react-datocms/dist/esm/Image/index.js + 3 modules
var Image = __webpack_require__(44087);
// EXTERNAL MODULE: ./node_modules/@narrative-software/narrative-web-ui/dist/index.js
var dist = __webpack_require__(67199);
;// CONCATENATED MODULE: ./src/components/SimpleHero/index.tsx



var SimpleHero = function(param) {
    var title = param.title, subtitle = param.subtitle, heroBackgroundImage = param.heroBackgroundImage, ctaText = param.ctaText, ctaHref = param.ctaHref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "w-full bg-mankey text-white text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "py-20 md:py-26 w-full relative px-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    data: heroBackgroundImage.responsiveImage,
                    layout: "fill"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative w-full max-w-[998px] mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-40 md:text-48 font-semibold mb-2",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-18",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.AnchorButton, {
                            colour: "white",
                            className: "md:max-w-[380px] mx-auto mt-5",
                            appearance: "primary",
                            href: ctaHref,
                            children: ctaText
                        })
                    ]
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./src/components/home/FeaturesSection.tsx
var FeaturesSection = __webpack_require__(15101);
// EXTERNAL MODULE: ./src/components/shared/IconFeatures3up.tsx
var IconFeatures3up = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/config/index.ts + 4 modules
var config = __webpack_require__(26499);
// EXTERNAL MODULE: ./src/modules/index.ts + 36 modules
var modules = __webpack_require__(18838);
;// CONCATENATED MODULE: ./src/pages/referrals.tsx










var ReferralsPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var ref = (0,useQuerySubscription/* useQuerySubscription */.L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, data = ref1.page;
    if (!data) return null;
    var seo = data.seo, heading = data.heading, subheading = data.subheading, heroBackgroundImage = data.heroBackgroundImage, ctaText = data.ctaText, referralsFaqs = data.referralsFaqs, featuresHeading = data.featuresHeading, benefits = data.benefits, referralFeatures = data.referralFeatures;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Layout */.Ar, {
        preview: preview,
        className: "justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SEO */.HJ, {
                title: "Narrative | Image selection | Blogging software | Photographers",
                imageUrl: "/images/share-image-select.jpg",
                children: (0,renderMetaTags/* renderMetaTags */.y)(seo)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHero, {
                title: heading,
                subtitle: subheading,
                heroBackgroundImage: heroBackgroundImage,
                ctaText: ctaText,
                ctaHref: config/* EXTERNAL.REFERRALS.HREF */.IK.REFERRALS.HREF
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFeatures3up/* IconFeatures3up */.n, {
                title: featuresHeading,
                items: referralFeatures
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesSection/* FeaturesSection */.G, {
                title: featuresHeading,
                sections: benefits.map(function(benefit) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, benefit), {
                        ctaHref: config/* EXTERNAL.REFERRALS.HREF */.IK.REFERRALS.HREF
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Accordion */.UQ, (0,_object_spread/* default */.Z)({
                className: "bg-white"
            }, referralsFaqs))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var referrals = (ReferralsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(64625); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);